export default __webpack_public_path__ + "3edc5229c48f7048b9646a1f20562e96.jpg";